import Resource from './Resource'

class SpainCnoOccupation extends Resource {
  static urlRoot() {
    return '/contracts/spain/cno_occupations'
  }
}

export default SpainCnoOccupation
